import React, { useState } from "react";
import "../../styles/ModalNuevoPaciente.css";
import { getNextExpediente, crearPaciente } from "../../services/pacienteService";

export default function ModalNuevoPaciente({ onClose, onGuardar }) {
    const [nombre, setNombre] = useState("");
    const [primerApellido, setPrimerApellido] = useState("");
    const [segundoApellido, setSegundoApellido] = useState("");
    const [movil, setMovil] = useState("");

    const guardar = async () => {
        const nExpediente = await getNextExpediente();

        const nuevoPaciente = await crearPaciente({
        n_expediente: nExpediente,
        nombre,
        primer_apellido: primerApellido,
        segundo_apellido: segundoApellido,
        movil,
        alta: new Date().toISOString().slice(0, 10)
        });

        onGuardar(nuevoPaciente);
    };

    return (
        <div className="modal-overlay">
        <div className="modal-content small">
            <h3>Nuevo paciente</h3>

            <label>Nombre</label>
            <input value={nombre} onChange={e => setNombre(e.target.value)} />

            <label>Primer apellido</label>
            <input value={primerApellido} onChange={e => setPrimerApellido(e.target.value)} />

            <label>Segundo apellido</label>
            <input value={segundoApellido} onChange={e => setSegundoApellido(e.target.value)} />

            <label>Móvil</label>
            <input value={movil} onChange={e => setMovil(e.target.value)} />

            <div className="acciones-modal">
            <button onClick={onClose}>Cancelar</button>
            <button
                className="btn-primary"
                disabled={!nombre || !primerApellido || !movil}
                onClick={guardar}
            >
                Guardar
            </button>
            </div>
        </div>
        </div>
    );
}
